"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.array.find.js");

require("core-js/modules/es.array.map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMobilePages = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _DecoratorsRoot = require("../../layout/DecoratorsRoot");

var _menu = require("../../constants/menu");

var _utils = require("../../nav/utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useMobilePages = function useMobilePages(pagesProps) {
  var _useContext = (0, _react.useContext)(_DecoratorsRoot.EnhancerContext),
      user = _useContext.user,
      isLogin = _useContext.isLogin,
      hasStoreAppPlugin = _useContext.hasStoreAppPlugin;

  var pages = pagesProps.map(function (page) {
    return _objectSpread(_objectSpread({}, page), {}, {
      pages: (0, _utils.getPages)(page, {
        user: user,
        isLogin: isLogin,
        hasStoreAppPlugin: hasStoreAppPlugin
      })
    });
  });
  var currencyPage = pages.find(function (page) {
    return page.action === _menu.MENU_ACTION_TYPES.CURRENCY;
  });
  var localePage = pages.find(function (page) {
    return page.action === _menu.MENU_ACTION_TYPES.LOCALE;
  });
  var otherPages = pages.filter(function (page) {
    return page.action !== _menu.MENU_ACTION_TYPES.CURRENCY && page.action !== _menu.MENU_ACTION_TYPES.LOCALE;
  });
  return {
    currencyPage: currencyPage,
    localePage: localePage,
    otherPages: otherPages,
    bottomPagesCount: [currencyPage, localePage].filter(Boolean).length
  };
};

exports.useMobilePages = useMobilePages;